module.exports = __webpack_public_path__ + "img/page58.fd632bc5.gif";